interface BarChartLegendItem {
  label: string;
  color: string;
}

interface BarChartProps {
  data: { label: string; value: number }[];
  color?: string;
  /** v2追加: 2本目の系列（例: 週次売上）。indexをdataと揃えて渡す。値がnullの月はバーを描かない。 */
  series2?: { label: string; value: number | null }[];
  color2?: string;
  legend?: BarChartLegendItem[];
}

/** 週次支出（＋v2で売上）チャート等に使う軽量な棒グラフ（外部ライブラリ非依存）。 */
export function BarChart({
  data,
  color = "var(--accent)",
  series2,
  color2 = "var(--ch-shopify-c)",
  legend,
}: BarChartProps) {
  const allValues = [...data.map((d) => d.value), ...(series2 ? series2.map((d) => d.value ?? 0) : [])];
  const max = Math.max(1, ...allValues);
  return (
    <div>
      <div className="bar-chart">
        {data.map((d, i) => {
          const pct = Math.max(2, Math.round((d.value / max) * 100));
          const s2 = series2?.[i];
          const pct2 = s2 && s2.value != null ? Math.max(2, Math.round((s2.value / max) * 100)) : null;
          return (
            <div className="bar-col" key={d.label}>
              <div className="bar-pair">
                <div
                  className="bar"
                  style={{ height: `${pct}%`, background: color }}
                  title={`${d.label}${legend?.[0]?.label ?? ""}: ${d.value.toLocaleString("ja-JP")}`}
                />
                {s2 && (
                  <div
                    className="bar"
                    style={{ height: pct2 !== null ? `${pct2}%` : "0%", background: color2, opacity: pct2 === null ? 0 : 1 }}
                    title={
                      s2.value != null
                        ? `${d.label}${legend?.[1]?.label ?? ""}: ${s2.value.toLocaleString("ja-JP")}`
                        : `${d.label}: データ欠損`
                    }
                  />
                )}
              </div>
              <span className="bar-label">{d.label}</span>
            </div>
          );
        })}
      </div>
      {legend && (
        <div className="bar-chart-legend">
          {legend.map((l) => (
            <span key={l.label} className="bar-chart-legend-item">
              <span className="dot" style={{ background: l.color }} />
              {l.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
